/**
 * @prettier
 */
import StandaloneLayout from "./components/StandaloneLayout"

const StandaloneLayoutPlugin = () => ({
  components: {
    StandaloneLayout,
  },
})

export default StandaloneLayoutPlugin
